<template>
  <div class="expertInfo">
    <div class="tips" id="tips"></div>
    <div class="list">
      <p>{{ intro.name }}</p>
      <van-swipe class="my-swipe" :autoplay="5000" indicator-color="white">
        <van-swipe-item
          v-for="(i, ind) in intro.photoList"
          v-if="i.type == 'cover'"
          :key="ind + 100"
        >
          <img :src="i.filePath" alt="" />
        </van-swipe-item>
      </van-swipe>
      <div class="title">专家介绍</div>
      <div v-html="intro.introduce"></div>
      <div class="title" v-if="intro.videoList && intro.videoList.length > 0">
        专家视频
      </div>
      <div class="videoList" v-if="intro.videoList && intro.videoList.length > 0">
        <div v-for="(item, index) in intro.videoList" :key="index">
          <video
            class="video-source"
            width="100%"
            controls
            webkit-playsinline="true"
            x-webkit-airplay="true"
            playsinline="true"
            x5-video-player-type="h5-page"
            x5-video-orientation="h5"
            x5-video-player-fullscreen="true"
            preload="auto"
            :poster="item.coverFilePath"
          >
            <source :src="item.filePath" type="video/mp4" />
          </video>
        </div>
      </div>
      <div class="title" v-if="videoShow">专家视频合集</div>
      <img
        v-for="(item, index) in intro.photoList"
        :key="index"
        v-if="item.type == 'advert'"
        class="videoImg"
        :src="item.filePath"
        alt=""
      />
    </div>
    <div class="back" v-if="!isiOS && !isApp" @click="backHome">返回</div>
    <!-- <Login v-if="loginTk" />
    <ChoiceCompany
      :choiceTk="choiceTk"
      :mobile="mobile"
      :companyList="companyList"
      v-if="choiceTk"
    /> -->
  </div>
</template>
<script>
import wxapi from "@/utils/wxapi";
import serivce from "@/utils/ajax";
import wx from "weixin-js-sdk";
import Login from "../components/login.vue";
import ChoiceCompany from "../components/choiceCompany.vue";
export default {
  components: {
    ChoiceCompany,
    Login,
  },
  data() {
    return {
      intro: {},
      isAndroid: false,
      videoShow: false,
      loginTk: false,
      choiceTk: false,
      isApp: false,
      mobile: "",
      companyList: [],
    };
  },
  created() {
    this.getInfo();
    // if (
    //   !localStorage.getItem("IntegratedTitle") ||
    //   !localStorage.getItem("userInfo")
    // ) {
    //   localStorage.setItem("IntegratedTitle", this.$route.query.from);
    //   this.loginTk = true;
    //   this.loginTrue = false
    // } else {
    //   this.loginTrue = true
    //   this.getInfo();
    // }

    var u = navigator.userAgent,
      app = navigator.appVersion;
    this.isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
    this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    // setTimeout(() => {
    //   let wxJs = wx;
    //   // let userId = JSON.parse(this.$store.getters.userInfo).id
    //   var that = this;
    //   wxJs.ready(() => {
    //     wxJs.onMenuShareTimeline({
    //       title: "幸福心联", // 分享标题
    //       desc: "幸福心联",
    //       link:
    //         process.env.VUE_APP_BASE_API +
    //         "/wx/#/expertInfo?info=" +
    //         that.$route.query.info,
    //       imgUrl: "",
    //       success: function () {
    //         let _that = that;
    //         console.log("share success");
    //       },
    //       cancel: function () {},
    //     });
    //     wxJs.onMenuShareAppMessage({
    //       title: "幸福心联", // 分享标题
    //       desc: "幸福心联",
    //       link:
    //         process.env.VUE_APP_BASE_API +
    //         "/wx/#/expertInfo?info=" +
    //         that.$route.query.info,
    //       imgUrl: "",
    //       success: function () {
    //         let _that = that;
    //         console.log("share success");
    //       },
    //       cancel: function () {},
    //     });
    //   });
    // }, 2000);
  },
  mounted() {
    // this.onClickOpens();
    let from = this.$route.query.from;

    if (from == "Seemo") {
      this.isApp = true;
    }
    console.log("from", from, this.isApp);
  },
  methods: {
    backHome() {
      this.$router.push({
        path: "/expert?from=幸福心联",
      });
    },
    tabCompany(companyList, phone) {
      this.mobile = phone;
      this.companyList = companyList;
      this.choiceTk = true;
    },
    onClickOpens() {
      serivce
        .get("/sp_api/sp/wxConfig", {
          appid: process.env.VUE_APP_BASE_APPID,
          url: window.location.href.split("#")[0],
        })
        .then((res) => {
          let data = res.data;
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: process.env.VUE_APP_BASE_APPID, // 必填，公众号的唯一标识
            timestamp: data.timestamp, // 必填，生成签名的时间戳
            nonceStr: data.noncestr, // 必填，生成签名的随机串
            signature: data.signature, // 必填，签名，见附录1
            openTagList: ["wx-open-launch-weapp"],
            ignoredElements: ["wx-open-launch-app", "wx-open-launch-weapp"],
            jsApiList: [
              "checkJsApi",
              "scanQRCode",
              "wx-open-launch-weapp",
              "onMenuShareTimeline",
              "onMenuShareAppMessage",
            ], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
        });
    },
    getInfo() {
      let params = {
        id: this.$route.query.id,
      };
      serivce.post(`/sp_api/spExpert/view`, params).then((res) => {
        if (res.code == 0) {
          this.intro = res.data;
          if (res.data.photoList.length > 0) {
            for (var i = 0; i < res.data.photoList.length; i++) {
              if (res.data.photoList[i].type == "advert") {
                this.videoShow = true;
              }
            }
          }
          document.title = res.data.name;
        } else {
          this.pupUp(res.msg);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.expertInfo {
  max-width: 750px;
  margin: 0 auto;
  padding-bottom: 1rem;
}
.list {
  padding: 0.3rem 0.3rem 0;
  p {
    font-size: 0.4rem;
    margin-top: 0;
    font-weight: bold;
    margin-bottom: 0.3rem;
  }
  .my-swipe {
    // height: rem;
    text-align: center;
    img {
      width: 80%;
      // height: 100%;
    }
  }
  .title {
    font-size: 0.4rem;
    margin: 0.3rem 0;
    font-weight: bold;
  }
  .intro {
    font-size: 0.3rem;
    margin: 0;
    line-height: 0.5rem;
  }
  video {
    width: 100%;
  }
  img.videoImg {
    width: 100%;
  }
}
.back {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 0.8rem;
  // padding: 0.2rem 0.3rem;
  background: #f7f7f7;
  line-height: 0.8rem;
  font-size: 0.32rem;
  // padding-left: 0.4rem;
  text-align: center;
}
</style>
